import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import {
    SERVICE_SETTINGS_EPRESCRIPTIONS_TYPE_DEFAULT,
    SERVICE_SETTINGS_EPRESCRIPTIONS_TYPE_KEY,
} from '@libs/types/src/services/types/service-settings-eprescription.type';
import { selectServiceSettings } from '../../../../store/service/service.selectors';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';

@Injectable()
export class ServiceSettingsEpoukazStore extends ComponentStoreV2Factory {
    private readonly ngrxStore = inject(Store);

    readonly eprescriptionSettings = toSignal(this.ngrxStore.select(
        selectServiceSettings(
            SERVICE_SETTINGS_EPRESCRIPTIONS_TYPE_KEY,
            SERVICE_SETTINGS_EPRESCRIPTIONS_TYPE_DEFAULT,
        ),
    ));
}
